import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

// Users
const UsersList = () => import(/* webpackChunkName: "users" */ '@/views/Users/List.vue');
const UserCreate = () => import(/* webpackChunkName: "users" */ '@/views/Users/Create.vue');
const UserEdit = () => import(/* webpackChunkName: "users" */ '@/views/Users/Edit.vue');

let usersPages = {
  path: '/users',
  redirect: '/users',
  component: DashboardLayout,
  name: 'Users',
  meta: {
    title: 'Usuarios',
  },
  children: [
    {
      path: '',
      name: 'UsersList',
      meta: {
        title: 'Listado',
        auth: ['users.index'],
      },
      component: UsersList,
    },
    {
      path: 'create',
      name: 'UserCreate',
      meta: {
        title: 'Nuevo',
        auth: ['users.store'],
      },
      component: UserCreate,
    },
    {
      path: ':id/edit',
      name: 'UserEdit',
      meta: {
        title: 'Editar',
        auth: ['users.update'],
      },
      component: UserEdit,
    },
  ],
};

export default usersPages;
